import { useTagsByPlaylistsQuery } from "src/types.g";
import { useAppContext } from "src/hooks/useAppContext";

export const useGetTagsByPlaylists = () => {
  const context = useAppContext();
  const spaceId = context?.currentSpace?.id;
  const tags = useTagsByPlaylistsQuery({
    variables: {
      spaceId,
      isShared: false,
    },
  });
  const sharedTags = useTagsByPlaylistsQuery({
    variables: {
      spaceId,
      isShared: true,
    },
  });
  return [
    ...(tags?.data?.tagsByPlaylists ?? []),
    ...(sharedTags?.data?.tagsByPlaylists ?? []),
  ];
};
